(function () {
  'use strict';

  function initHeroSliders() {
    document.querySelectorAll('[data-hero-slider]').forEach(function (el) {
      if (el.swiperInstance) return;
      var delay = parseInt(el.dataset.autoplayDelay, 10) || 5000;
      el.swiperInstance = new Swiper(el, {
        loop: true,
        speed: 600,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        autoplay: { delay: delay, disableOnInteraction: false },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  }

  if (typeof Swiper !== 'undefined') {
    initHeroSliders();
  } else {
    window.addEventListener('load', initHeroSliders);
  }
})();
